/** sessionStorage key — dismiss hides popup until the browser session ends. */
export const FAILED_INSTALMENT_POPUP_DISMISSED_SESSION_KEY =
  'certificates.failedInstalmentPopup.dismissed';
